import { render, staticRenderFns } from "./serviceConcessionApproval.vue?vue&type=template&id=9647f7d0"
import script from "./serviceConcessionApproval.vue?vue&type=script&lang=js"
export * from "./serviceConcessionApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports